import { put, call } from 'redux-saga/effects';
import { apiRequestEnd, apiRequestStart } from '../../store/application/actions';

export default function* sagaUtility(
    requestData: any,
    apiMethod: any,
    successAction: any,
    failureAction: any,
    shouldReturnRequest: boolean = false,
    showLoadingBar = true
): any {
    try {
        if (showLoadingBar) {
            yield put(apiRequestStart.request());
        }
        const response = yield call(apiMethod, requestData);
        yield proccessResponse(response.data, successAction, shouldReturnRequest, requestData);
    } catch (err) {
        yield proccessError(err, failureAction, shouldReturnRequest, requestData);
    } finally {
        if (showLoadingBar) {
            yield put(apiRequestEnd.request());
        }
    }
}

function* proccessResponse(responseData: any, actionSuccess: any, shouldReturnRequest: any, request: any) {
    if (!shouldReturnRequest && !responseData) {
        yield put(actionSuccess());
    }
    else if (!shouldReturnRequest && responseData) {
        yield put(actionSuccess(responseData));
    }
    else if (shouldReturnRequest && !responseData) {
        yield put(actionSuccess(request));
    }
    else if (shouldReturnRequest && responseData) {
        yield put(actionSuccess({ ...responseData, request }));
    }
}

function* proccessError(error: any, failureAction: any, shouldReturnRequest: any, request: any) {
    if (!shouldReturnRequest) {
        yield put(failureAction(error));
    }
    else {
        yield put(failureAction({ error: error, request }));
    }
}
